import { uniqueId } from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSafeImageSrc } from '../../../SafeImage';
import useSVGBackgroundImage from '../../../SVG/useSVGBackgroundImage';

function ConnectionSideUser(props) {
    const { user, baseRoute = '', onShowAvatarModal } = props,
        src = useSafeImageSrc(user.image_url, '/img/no_avatar.png'),
        [imageId] = useState(() => uniqueId('pattern-')),
        r = 85,
        targetPath = useMemo(
            () =>
                [
                    baseRoute,
                    user.user_id ?? user.id ?? '-',
                    user.participant_id ?? '-',
                ].join('/'),
            [baseRoute, user]
        ),
        [, background, Background] = useSVGBackgroundImage({
            size: r * 2,
            src,
        }),
        { userId: currentUserId } = useParams();

    const handleOpenUser = useCallback(() => {
        if ((user.user_id ?? user.id) == currentUserId) {
            if (onShowAvatarModal) onShowAvatarModal(user);
        } else {
            app.history.push(targetPath);
        }
    }, [targetPath]);

    return (
        <>
            <Background />
            <circle
                cx='96'
                cy='96'
                r={r}
                fill={background}
                onClick={handleOpenUser}
            />
        </>
    );
}

export default ConnectionSideUser;
